import FJCheckBox from '../FJCheckBox/FJCheckBox';
import CloseIcon from '../../../assets/svg/close.svg?react';
import DownloadIcon from '../../../assets/svg/download-black.svg?react';
import DeleteBlackIcon from '../../../assets/svg/delete-black.svg?react';
import DeleteIcon from '../../../assets/svg/delete.svg?react';
import styles from './FJSelectAll.module.less';
import FJIconButton from '../FJIconButton/FJIconButton';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ApplyIcon from '../../../assets/svg/apply.svg?react';
import AddMediaIcon from '../../../assets/svg/add-to-media.svg?react';
import FJToolTip from '../FJToolTip/FJToolTip.jsx';
import FJConstant from '../../../constants/FJConstant.js';
import FJVideoEditIcon from '../../../assets/svg/video-edit-select-box.svg?react';
import FJAppConstant from '../../../constants/FJAppConstant.js';

const FJSelectAll = props => {
    const {
        appType,
        list,
        selectList,
        multiDownload,
        multiDelete,
        setSelectList,
        batchDownloadLoading,
        addAsEditPageModalBtuStatus,
        hideDownload = false,
        useApplyButton = false,
        onApply,
        onAddToMediaLibrary,
        isShowAddToMediaButton = false,
        isShowAddToEditPageButton = false,
        isMultipleMode = false,
        clearSelected,
        addAsEditPage,
    } = props;
    const isShow = selectList.length > 0 || isMultipleMode;
    const selectNumber = selectList.length;

    const showApplyButton = useApplyButton && selectNumber === 1;

    const filterList = list.filter(i => i.status !== 'progress');

    const _clearSelected = () => {
        clearSelected && clearSelected();
        setSelectList([]);
    };
    const isSelectedAll = selectList?.length >= filterList?.length;
    const _selectAll = () => {
        if (isSelectedAll) {
            setSelectList([]);
        } else {
            setSelectList(filterList.map(i => i?.id));
        }
    };
    const _onBatchDownload = () => {
        if (batchDownloadLoading) {
            return;
        }
        multiDownload && multiDownload(selectList, 'multiple choose');
    };

    const isVideo =
        appType === FJAppConstant.AI_VIDEO_GENERATOR ||
        appType === FJAppConstant.VIDEO_REMOVE_BG ||
        appType === FJAppConstant.AI_VIDEO_DUB;
    const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;
    const isDisabledOfDownload = useMemo(() => {
        if (isVideo || isAudioGenerator) {
            try {
                return (
                    selectList.filter(i => filterList.find(j => j.id === i && j.status === 'failed')).length ===
                    selectList.length
                );
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }, [isVideo, isAudioGenerator, selectList, filterList]);

    const _onAddToMediaLibrary = () => {
        if (!onAddToMediaLibrary) return;
        const selectedList = list.filter(item => selectList.includes(item.id));
        const sList = selectedList.map(item => (isAudioGenerator ? item.audioUrl : item.imgUrl));
        onAddToMediaLibrary(sList);
    };

    const _onAddToEditPage = () => {
        if (!addAsEditPage) return;
        addAsEditPage && addAsEditPage(selectList);
    };

    const _onApplyMedia = () => {
        if (!onApply) return;

        const selectedId = selectList[0];
        const selectedItem = list.find(item => item.id == selectedId);
        if (selectedItem) {
            onApply(isAudioGenerator ? selectedItem.audioUrl : selectedItem.imgUrl);
        }
    };

    const _getSelectText = () => {
        if (isVideo) {
            return selectNumber > 1 ? FJLocalStore._('videos-selected') : FJLocalStore._('video-selected');
        } else if (isAudioGenerator) {
            return FJLocalStore._('music-selected');
        } else {
            return selectNumber > 1 ? FJLocalStore._('files-selected') : FJLocalStore._('file-selected');
        }
    };

    const _renderButtonForEditPage = () => {
        return (
            <>
                {!hideDownload && (
                    <FJToolTip title={'download'}>
                        <div style={{ marginRight: 12 }}>
                            <FJIconButton
                                icon={<DownloadIcon />}
                                onClick={_onBatchDownload}
                                style={{ padding: 0, width: 40, height: 40 }}
                                isLoading={batchDownloadLoading}
                                loadingSize={16}
                                disabled={isDisabledOfDownload}
                            />
                        </div>
                    </FJToolTip>
                )}
                <FJToolTip title={'delete'}>
                    <div style={{ marginRight: 12 }}>
                        <FJIconButton
                            icon={<DeleteBlackIcon />}
                            onClick={() => multiDelete(selectList)}
                            style={{ padding: 0, width: 40, height: 40 }}
                            disabled={selectList.length === 0}
                        />
                    </div>
                </FJToolTip>

                {isShowAddToMediaButton && (
                    <FJIconButton
                        textClassName={styles.button_text}
                        text={FJLocalStore._(showApplyButton ? 'apply' : 'add-to-media')}
                        icon={showApplyButton ? <ApplyIcon /> : <AddMediaIcon />}
                        type={'gradient'}
                        onClick={showApplyButton ? _onApplyMedia : _onAddToMediaLibrary}
                        disabled={selectList.length === 0}
                    />
                )}
            </>
        );
    };

    const _renderButton = () => {
        return (
            <>
                {!hideDownload && (
                    <FJToolTip title={'download'}>
                        <div style={{ marginRight: 12 }}>
                            <FJIconButton
                                icon={<DownloadIcon />}
                                onClick={_onBatchDownload}
                                style={{ padding: 0, width: 40, height: 40 }}
                                isLoading={batchDownloadLoading}
                                loadingSize={16}
                                disabled={isDisabledOfDownload}
                            />
                        </div>
                    </FJToolTip>
                )}
                <FJToolTip title={'delete'}>
                    <div style={{ marginRight: 12 }}>
                        <FJIconButton
                            icon={<DeleteBlackIcon />}
                            onClick={() => multiDelete(selectList)}
                            style={{ padding: 0, width: 40, height: 40 }}
                            disabled={selectList.length === 0}
                        />
                    </div>
                </FJToolTip>

                {isShowAddToEditPageButton && (
                    <FJIconButton
                        textClassName={styles.button_text}
                        text={FJLocalStore._('upload')}
                        icon={<FJVideoEditIcon />}
                        type={'gradient'}
                        strokeColor={'#fff'}
                        onClick={_onAddToEditPage}
                        disabled={selectList.length === 0}
                        isLoading={addAsEditPageModalBtuStatus === FJConstant.LOADING}
                    />
                )}
            </>
        );
    };

    return (
        <div className={classNames(styles.select_all_box, isShow ? styles.show : styles.hide)}>
            <FJCheckBox dataChange={_selectAll} selected={isSelectedAll} value={FJLocalStore._('select-all')} />
            <div className={styles.middle}>
                <div className={styles.select_number}>{selectNumber}</div>

                <div className={styles.select_desc}>{_getSelectText()}</div>
                {window.isEditPage ? _renderButtonForEditPage() : _renderButton()}
            </div>
            <div className={styles.close_btn_box} onClick={_clearSelected}>
                <CloseIcon className={styles.close_icon} />
            </div>
        </div>
    );
};
FJSelectAll.propTypes = {
    appType: PropTypes.string,
    list: PropTypes.array,
    selectList: PropTypes.array,
    multiDownload: PropTypes.func,
    multiDelete: PropTypes.func,
    setSelectList: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
    hideDownload: PropTypes.bool,
    clearSelected: PropTypes.func,
};
export default FJSelectAll;
